import React from 'react';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { Col, Button } from 'antd';
import { FaQuestionCircle, FaMapMarkerAlt } from 'react-icons/fa';
import i18n from 'i18next';

export interface LocationParams {
  location: any;
}

export const ContactSupport: React.FC = () => {
  const history: History = useHistory();

  const handleButtonClick = () => history.push('/settings/contactus');

  return (
    <div className="form-bottom-item profile-contact-container ">
      <Button
        block
        type="link"
        onClick={handleButtonClick}
        className="profile-contact-support"
      >
        <FaQuestionCircle />
        {i18n.t('Contact Support')}
      </Button>
    </div>
  );
};

export const ProfileLocation: React.FC<LocationParams> = ({ location }) => {
  return (
    <Col className="profile-description profile-location">
      {Object.keys(location).length === 0 || location === undefined ? (
        ''
      ) : (
        <FaMapMarkerAlt color="#A8A8A8" />
      )}
      <span>
        {Object.keys(location).length === 0 || location === undefined
          ? ''
          : `${location.street} - ${location.city}`}
      </span>
    </Col>
  );
};
